import React from 'react';
import captureScreen from '../../utils/capture';
// グローバル CSS に移行したため直接クラス名を使います

function DownloadButton({ renderer, scene, camera, glbPath }) {
  const handleClick = () => {
    if (renderer && scene && camera) {
      captureScreen(renderer, scene, camera, glbPath);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="btn btn--small"
    >
      2D画像をDLする
    </button>
  );
}

export default DownloadButton;